import { IImagesList } from 'components/photo-viewer/entities';
import { isVideo } from 'components/uploaded-images/helpers';
import { IPostUploads, TActivityFeedDraftItemUploads } from 'redux-store/api/activity-feed';

export const isPostDraftUpload = (
  data: TActivityFeedDraftItemUploads[number]
): data is IPostUploads => {
  if ('options' in data) return true;
};

const isPostDraftUploads = (data: TActivityFeedDraftItemUploads): data is IPostUploads[] => {
  if ('options' in data[0]) return true;
};

export const adaptMediaForPhotoViewer = (
  data: TActivityFeedDraftItemUploads,
  videoThumbnails?: Map<string, string>
): IImagesList[] => {
  if (isPostDraftUploads(data)) {
    return data.map(({ mimeType, url, options, id, description, location, timestamp }, index) => {
      const isVideoItem = isVideo(mimeType);
      const videoPreview = isVideoItem
        ? (options?.previewUrl || videoThumbnails?.get(id) || '')
        : '';

      return {
        id: index,
        imageSrc: url,
        thumbnail: isVideoItem ? (videoPreview || '') : url,
        mimeType,
        previewUrl: videoPreview,
        itemId: id,
        description,
        location,
        timestamp,
      };
    });
  }

  return data.map((image, index) => ({
    id: index,
    imageSrc: image.url,
    thumbnail: image.url,
    itemId: image.id,
    ...('description' in image &&
      typeof image.description === 'string' && { description: image.description }),
  }));
};
